import { render, staticRenderFns } from "./gatherdetail.vue?vue&type=template&id=5020c559&scoped=true"
import script from "./gatherdetail.vue?vue&type=script&lang=js"
export * from "./gatherdetail.vue?vue&type=script&lang=js"
import style0 from "./gatherdetail.vue?vue&type=style&index=0&id=5020c559&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020c559",
  null
  
)

export default component.exports